import { FaCheck } from "react-icons/fa6";

import { cn } from "shared/utils/cn";

type Props = {
  className?: string;
  title: string;
  description: string;
  onClick: () => void;
  isActive: boolean;
};

export const Option = (props: Props) => {
  const { className, onClick, title, description, isActive } = props;

  return (
    <li
      className={cn(
        "border-dark-grey bg-oil flex cursor-pointer border-b px-4 py-2.5 transition-colors last:border-none hover:brightness-125",
        className
      )}
      onClick={onClick}
    >
      <div className="flex grow items-center justify-between">
        <div className="flex flex-col text-white">
          <span className="flex text-[17px] leading-5.5 tracking-[0.43px]">
            {title}
          </span>
          <span className="flex text-sm leading-4.5 tracking-[0.15px]">
            {description}
          </span>
        </div>
        {isActive && <FaCheck className="text-clear-blue size-5" />}
      </div>
    </li>
  );
};
